import { Resource } from "i18next";

import { createInstance } from "@digital-services/ui/i18n";

import translationEN from "./locales/en.json";
import translationNL from "./locales/nl.json";
import { DEFAULT_LANGUAGE } from "./utils/common";

const resources: Resource = {
  en: { translation: translationEN },
  nl: { translation: translationNL }
};

const instance = createInstance(resources);

// Default logic of MSAL is to use default value for claim `language` = 'en-US' but we don't have such JSON in Azure Storage that is why it FAILS 404 all the time.
// With old approach we could set `fallbackLng` while i18next instance init() but now it's NOT possible because of new way in `@digital-services/ui/i18n`.
// As result i18next receives same 'en-US' wrong language and then FOTA loses all translations, because we use "en" as default language.
// That is why we need to set language here 100%
instance.changeLanguage(DEFAULT_LANGUAGE);

export default instance;

// More about i18next https://www.i18next.com/overview/configuration-options
// Note that since i18next>=21.3.0 you can use the built-in formatting functions based on the Intl API
// https://www.i18next.com/translation-function/formatting
// In FOTA we don't even use any custom formatters inside of translation JSON entries
// Note also that i18next > v26 as BREAKING changes, and refactoring in future may bring changes here
// https://www.i18next.com/misc/migration-guide
